import c from "./extends3.mjs";
import T from "./objectWithoutPropertiesLoose3.mjs";
import * as $ from "react";
import { ClearIcon as b } from "./index243.mjs";
import { jsxs as g, jsx as i } from "react/jsx-runtime";
import { useLocaleText as j } from "./useUtils.mjs";
import L from "./IconButton.mjs";
import { useSlotProps as I } from "./useSlotProps.mjs";
import M from "./InputAdornment.mjs";
const R = ["ownerState"], D = ({
  clearable: p,
  fieldProps: t,
  InputProps: l,
  onClear: v,
  slots: n,
  slotProps: e,
  components: o,
  componentsProps: r
}) => {
  var a, u, m, s, d, f;
  const _ = j(), x = (a = (u = n?.clearButton) != null ? u : o?.ClearButton) != null ? a : L, C = I({
    elementType: x,
    externalSlotProps: (m = e?.clearButton) != null ? m : r?.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: _.fieldClearLabel
    }
  }), S = T(C, R), B = (s = (d = n?.clearIcon) != null ? d : o?.ClearIcon) != null ? s : b, h = I({
    elementType: B,
    externalSlotProps: (f = e?.clearIcon) != null ? f : r?.clearIcon,
    ownerState: {}
  }), y = c({}, l, {
    endAdornment: /* @__PURE__ */ g($.Fragment, {
      children: [p && /* @__PURE__ */ i(M, {
        position: "end",
        sx: {
          marginRight: l != null && l.endAdornment ? -1 : -1.5
        },
        children: /* @__PURE__ */ i(x, c({}, S, {
          onClick: v,
          children: /* @__PURE__ */ i(B, c({
            fontSize: "small"
          }, h))
        }))
      }), l?.endAdornment]
    })
  }), A = c({}, t, {
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(t.sx) ? t.sx : [t.sx]]
  });
  return {
    InputProps: y,
    fieldProps: A
  };
};
export {
  D as useClearableField
};
//# sourceMappingURL=useClearableField.mjs.map
